import { registerServerErrorMessageMap } from '@odc/od-react-belt'
import { ErrorCode } from '@storyplay/common'

export function registerServerErrorMessages() {
  registerServerErrorMessageMap(
    ErrorCode.OTPTokenIsNotCorrect,
    '인증번호가 올바르지 않습니다.'
  )
}
